<template lang="pug">
    el-dialog(:title="!ruleForm.byx1 ? '添加': '修改'", :fullscreen="false" :visible.sync='visible' :modal-append-to-body='false' :append-to-body='true' @close="visible=false")
      el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="90px",label-position='right' @submit.native.prevent)
        el-form-item(label="名　　称:" prop="title")
            el-input(style='width:100%;' v-model="ruleForm.title" placeholder="请输入模板名称")
        el-form-item(label="设　　置:" prop="feeList" )
            el-table(:data="ruleForm.feeList" border)
                el-table-column(prop="name" label="角色" align='center')
                el-table-column(prop="value" label="报名费用" align='center')
                    template(slot-scope="scope")
                        font ￥&nbsp;&nbsp;
                        el-input-number(v-model ="scope.row.value" :precision="2" :min="0" :max="1000000")
                        font &nbsp;&nbsp;元

        el-form-item(label="模板介绍:" prop="remark" )
            el-input(type='textarea' :rows='5' resize='none' v-model="ruleForm.remark" placeholder="请输入模板介绍")

      span.dialog-footer(slot="footer")
          el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 确 定
          el-button(@click="visible=false") 取 消
</template>
<script>
    export default {
        data () {
            return {
                clickFlag: false,
                ruleForm: {
                    id: null,
                    byx1: '',
                    title: '',
                    remark: '',
                    feeList: [
                        { typeTemp: 1, typeRole: 1, typeVal: 1, name: '注册会员', value: 0.00 },
                        { typeTemp: 1, typeRole: 1, typeVal: 2, name: '初始会员', value: 0.00 },
                        { typeTemp: 1, typeRole: 1, typeVal: 3, name: '荣誉会员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 1, name: '在职人员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 2, name: '在校人员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 3, name: '退休人员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 4, name: '志愿者', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 5, name: '家长', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 6, name: '其他', value: 0.00 }
                    ]
                },
                flagType: '',
                loading: null,
                rules: {
                    title: [
                        { required: true, message: '名称不能为空!', trigger: 'blur' },
                        { max: 50, message: '长度不能超过50个字符!' }
                    ],
                    remark: [
                        { required: true, message: '模板介绍不能为空!', trigger: 'blur' },
                        { max: 500, message: '长度不能超过500个字符!' }
                    ]
                },
                visible: false
            }
        },
        methods: {
            init (byx1, flagType) {
                console.log('初始化数据回显：', byx1)
                this.clickFlag = false
                this.flagType = flagType
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                })
                //数据初始化
                this.ruleForm = {
                    id: null,
                    byx1: byx1 || null,
                    title: '',
                    remark: '',
                    feeList: [
                        { typeTemp: 1, typeRole: 1, typeVal: 1, name: '注册会员', value: 0.00 },
                        { typeTemp: 1, typeRole: 1, typeVal: 2, name: '初始会员', value: 0.00 },
                        { typeTemp: 1, typeRole: 1, typeVal: 3, name: '荣誉会员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 1, name: '在职人员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 2, name: '在校人员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 3, name: '退休人员', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 4, name: '志愿者', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 5, name: '家长', value: 0.00 },
                        { typeTemp: 1, typeRole: 2, typeVal: 6, name: '其他', value: 0.00 }
                    ]
                }
                //修改回选
                if (this.ruleForm.byx1) {
                    this.$http({
                        url: this.$http.adornUrl(`/pbFeeTemplate/getByByx1/` + this.ruleForm.byx1),
                        method: 'get'
                    }).then((data) => {
                        if (data && data.code === 0) {
                            console.log('data222:', data.list[0])
                            this.ruleForm.title = data.list[0].title
                            this.ruleForm.remark = data.list[0].remark
                            this.ruleForm.feeList = data.list
                            console.log('初始化后的数据22：', this.ruleForm)
                            console.log('初始化后的数据33：', this.ruleForm.feeList)
                        }
                    })
                }
            },
            openFullScreen () {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            //新增方法
            ruleFormSubmit () {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.openFullScreen()
                        this.clickFlag = true
                        console.log('要提交的数据1：', this.ruleForm.feeList)
                        this.ruleForm.feeList.forEach(e => {
                            e.title = this.ruleForm.title
                            e.remark = this.ruleForm.remark
                            e.byx1 = this.ruleForm.byx1
                        })
                        console.log('要提交的数据2：', this.ruleForm.feeList)
                        this.$http({
                            url: this.$http.adornUrl(`/pbFeeTemplate/saveList`),
                            method: 'post',
                            data: this.ruleForm.feeList
                        }).then((data) => {
                            this.loading.close()
                            console.log('提交后返回的结果：', data)
                            if (data && data.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.flagType = 1
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            }
        }
    }
</script>
<style>
    .inputWidth{
        width: 210px;
    }

    .font_later{
        padding-left:20px;
        font-weight: bold;
        color: #909399;
    }
    .font_color{
        font-weight: bold;
        color: #909399;
    }
    .font_style{
        font-weight: bold;
        color: red;
    }
    .dialog-footer{
        padding-bottom:150px;
    }

    /* 提示框 */
.el-tooltip__popper.is-light{
  border: 1px solid #C0C4CC;
}

.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: grey  !important ;
}

.toolTip>p{
  margin: 0;
  padding-top: 10px;
  height:14px;
  line-height:14px;
  font-size:14px;
  color: #606266;
}

 /* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

</style>
